/*
 * DAW · Barre d'annonce du drop.
 *
 * Trois responsabilités, rien de plus :
 *   1. faire tourner le compte à rebours ;
 *   2. basculer du message d'attente au message « drop en cours » à l'heure
 *      dite, puis retirer la barre à la fin de la fenêtre, sans rechargement ;
 *   3. la fermeture par la croix, et la fenêtre « M'alerter ».
 *
 * La décision d'afficher ou non est prise côté serveur (Liquid) : ce fichier ne
 * fait jamais apparaître une barre que le serveur n'a pas rendue.
 *
 * Le masquage d'une barre déjà fermée est fait par un petit script en ligne
 * dans la section, avant peinture — sinon elle apparaîtrait puis sauterait.
 */
(function () {
  'use strict';

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function init(root) {
    var ts = parseInt(root.getAttribute('data-ts'), 10) || 0;
    var end = parseInt(root.getAttribute('data-end'), 10) || 0;
    var phase = root.getAttribute('data-phase') || 'before';
    var design = root.getAttribute('data-design') === 'true';

    var before = root.querySelector('[data-daw-ann-before]');
    var during = root.querySelector('[data-daw-ann-during]');
    var clock = root.querySelector('[data-daw-ann-clock]');
    var closeBtn = root.querySelector('[data-daw-ann-close]');
    var alertBtn = root.querySelector('[data-daw-ann-alert]');
    var dialog = document.querySelector('[data-daw-ann-dialog]');

    var cellD = root.querySelector('[data-daw-d]');
    var cellH = root.querySelector('[data-daw-h]');
    var cellM = root.querySelector('[data-daw-m]');
    var cellS = root.querySelector('[data-daw-s]');

    var timer = null;

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function tick() {
      var now = Math.floor(Date.now() / 1000);
      var left = ts - now;

      if (left > 0) {
        if (cellD) cellD.textContent = pad(Math.floor(left / 86400));
        if (cellH) cellH.textContent = pad(Math.floor((left % 86400) / 3600));
        if (cellM) cellM.textContent = pad(Math.floor((left % 3600) / 60));
        if (cellS) cellS.textContent = pad(left % 60);
      } else if (cellD) {
        cellD.textContent = '00';
        cellH.textContent = '00';
        cellM.textContent = '00';
        cellS.textContent = '00';
      }

      /* Dans l'éditeur de thème, l'état affiché est celui choisi dans les
         réglages : on met les chiffres à jour, mais on ne bascule ni ne
         retire rien. */
      if (design) return;

      if (end && now >= end) {
        stop();
        root.parentNode && root.parentNode.removeChild(root);
        return;
      }

      if (left <= 0) {
        if (before) before.hidden = true;
        if (during) during.hidden = false;
        if (clock) clock.hidden = true;
      }
    }

    tick();
    timer = setInterval(tick, 1000);

    /* La croix. La clé retient le drop ET la phase : une barre fermée pendant
       l'attente réapparaît une fois le drop ouvert, avec l'autre message. */
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        try {
          window.localStorage.setItem('daw_ann_' + ts + '_' + phase, '1');
        } catch (e) {}
        stop();
        if (root.parentNode) root.parentNode.removeChild(root);
      });
    }

    /* Le bouton « M'alerter » disparaît pour qui s'est déjà inscrit. */
    try {
      if (alertBtn && window.localStorage.getItem('daw_signup_done') === '1') {
        alertBtn.hidden = true;
      }
    } catch (e) {}

    if (alertBtn && dialog) {
      alertBtn.addEventListener('click', function () {
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          /* Navigateur sans <dialog> : on envoie vers la page DROP, qui porte
             le même formulaire. */
          window.location.href = alertBtn.getAttribute('data-fallback') || '/';
        }
      });

      var dialogClose = dialog.querySelector('[data-daw-ann-dialog-close]');
      if (dialogClose) {
        dialogClose.addEventListener('click', function () {
          dialog.close();
        });
      }

      /* Clic sur le fond : la fenêtre elle-même dépasse son contenu, on ne
         ferme que si la cible est bien le fond. */
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });

      /* Inscription réussie : on retient, on ferme, et le bouton s'efface.
         On observe la classe du message plutôt que d'aller modifier le
         script d'inscription, partagé avec la page DROP. */
      var msg = dialog.querySelector('[data-daw-signup-msg]');
      if (msg && window.MutationObserver) {
        var observer = new MutationObserver(function () {
          if (msg.className.indexOf('daw-signup__msg--ok') === -1) return;
          try {
            window.localStorage.setItem('daw_signup_done', '1');
          } catch (e) {}
          observer.disconnect();
          window.setTimeout(function () {
            if (dialog.open) dialog.close();
            if (alertBtn) alertBtn.hidden = true;
          }, 2400);
        });
        observer.observe(msg, { attributes: true, attributeFilter: ['class'] });
      }
    }
  }

  function boot() {
    var roots = document.querySelectorAll('[data-daw-ann]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* L'éditeur de thème recharge la section sans recharger la page. */
  document.addEventListener('shopify:section:load', boot);
})();
